/**
 * El árbol de providers. **El orden no es arbitrario:**
 *
 *   QueryClientProvider   ← lo necesitan Auth (para limpiar cache) y Tenant
 *     ApiProvider         ← lo necesita Auth (login/logout)
 *       AuthProvider      ← da el tenant de la sesión
 *         TenantProvider  ← da locale, huso y moneda
 *           I18nProvider  ← formatea con lo que dio Tenant
 *             children
 *
 * Invertir dos de estos rompe con "useX fuera de <XProvider>", que es el
 * error que este comentario existe para evitar.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { ApiProvider } from '@/api/ApiProvider';
import { AuthProvider } from '@/auth/AuthProvider';
import { I18nProvider } from '@/i18n/I18nProvider';
import { TenantProvider } from '@/tenant/TenantProvider';
import type { AppRuntime } from './runtime';

export function AppProviders({
  runtime,
  children,
}: {
  runtime: AppRuntime;
  children: ReactNode;
}): ReactNode {
  return (
    <QueryClientProvider client={runtime.queryClient}>
      <ApiProvider client={runtime.api}>
        <AuthProvider tokens={runtime.tokens} registerSessionEndHandler={runtime.onSessionEnd}>
          <TenantProvider fetchImpl={runtime.fetchImpl}>
            <I18nProvider>{children}</I18nProvider>
          </TenantProvider>
        </AuthProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
